export default __webpack_public_path__ + "static/media/include_8_female@2x.9ed80ca1.jpg";